<template>
    <vue-loader-component :isGlobalWork="loading.status" wrapperClass="wrapperLoaderFixed" :loadMessage="loading.message"></vue-loader-component>
    <!-- <VueSelectHtml :selected="directionId" :optionsList="directionsOptions" ></VueSelectHtml> -->
    <select class="form-control directionSelect" name="direction_id" v-model="directionId" @change="resetDirection()">
        <option :value="null" :selected="!directionId || directionId == 0">--- выберите направление ---</option>
        <option v-for="(opt, index) in directionsOptions" :value="opt.value" :selected="opt.value == directionId">{{ opt.label }}</option>
    </select>

    <div class="bg-primary-o-20 rounded-sm p-5 mb-5 font-size-h6">Общая стоимость: <strong>{{ checkPrice }}</strong></div>
    <div class="bg-warning-o-20 rounded-sm p-5 mb-5 font-size-h6">Общая продолжительность: <strong>{{ checkDeadlines }}</strong></div>

    <div class="structureAccordion">
        <div class="structureBlock" v-for="(department, indexDepartment) in structure" :index="indexDepartment" v-if="structure">
            <div class="elementBlock">
                <div class="indexBlock">{{ department.label }} ORDER: {{ department.order }}</div>
                <div class="structureBlock" v-for="(workshop, indexWorkshop) in department.workshops" :index="indexWorkshop" v-if="department.workshops">
                    <div class="elementBlock">
                        <div class="indexBlock">{{ workshop.label }} ORDER: {{ workshop.order }}</div>
                        <div class="structureBlock" v-for="(productionWork, indexProductionWork) in workshop.productionWorks" :index="indexProductionWork" v-if="workshop.productionWorks">
                            <div class="elementBlock">
                                <div class="checkboxInput" @click="productionWork.check = !productionWork.check">
                                    <input type="checkbox" v-model="productionWork.check" :name="'productionWorks['+productionWork.id+'][id]'" :value="productionWork.id" :id="'productionWork_'+productionWork.id">
                                    <div class="decorateCheck">
                                        <div class="la la-grin-beam-sweat" v-if="!productionWork.check"></div>
                                        <div class="la la-check-double" v-if="productionWork.check"></div>
                                    </div>
                                    <label>{{ productionWork.label }} {{ productionWork.id }} {{ productionWork.check }}</label>
                                </div>
                                <Transition name="fade">
                                <div class="blockRequisite" v-if="productionWork.check">
                                    <div class="itemRequisite">
                                        <div class="name">Цена</div>
                                        <input v-model="productionWork.price" :name="'productionWorks['+productionWork.id+'][price]'" class="form-control form-control-lg form-control-solid numberInput" type="text">
                                    </div>
                                    <div class="itemRequisite">
                                        <div class="name">Срок</div>
                                        <input v-model="productionWork.deadlines" :name="'productionWorks['+productionWork.id+'][deadlines]'" class="form-control form-control-lg form-control-solid numberInput" type="text">
                                    </div>
                                    <input v-model="productionWork.label" :name="'productionWorks['+productionWork.id+'][label]'" type="hidden">
                                    <input v-model="productionWork.order" :name="'productionWorks['+productionWork.id+'][order]'" type="hidden">
                                </div>
                                </Transition>

                                <div class="structureBlock" v-if="productionWork.productionSubsWorks && productionWork.productionSubsWorks.length > 0 && productionWork.productionSubsWorks.find(item => item.check == true)">
                                    <div class="elementBlock">
                                        <div v-for="(productionSubsWork, indexProductionSubsWork) in productionWork.productionSubsWorks" :index="indexProductionSubsWork">
                                            <div class="checkboxInput" v-if="productionSubsWork.check">
                                                <input type="checkbox" v-model="productionSubsWork.check" :name="'productionWorks['+productionWork.id+'][productionSubsWork][id]'">
                                                <div class="decorateCheck">
                                                    <div class="la la-grin-beam-sweat" v-if="!productionSubsWork.check"></div>
                                                    <div class="flaticon-alarm" v-if="productionSubsWork.check"></div>
                                                </div>
                                                <label>{{ productionSubsWork.label }} {{ productionSubsWork.id }} {{ productionSubsWork.check }}</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="bg-primary-o-20 rounded-sm p-5 m-5 font-size-h6">Общая стоимость: <strong>{{ checkPrice }}</strong></div>
    <div class="bg-warning-o-20 rounded-sm p-5 m-5 font-size-h6">Общая продолжительность: <strong>{{ checkDeadlines }}</strong></div>

    <!-- <textarea style="width: 100%; height: 300px;">{{ directionId }}</textarea> -->
    <textarea style="width: 100%; height: 300px;">{{ this.structure_arr }}</textarea>
    <!-- <textarea style="width: 100%; height: 300px;">{{ directionsOptions }}</textarea> -->
    <textarea style="width: 100%; height: 300px;">{{ structure }}</textarea>
</template>
<script>
// import VueSelectHtml from '@/Components/VueSelectHtml.vue';

export default {
    props: {
        direction_id: {type: Number, default: null},
        structure_arr: {type: Object, default: null},
    },
    // components: { VueSelectHtml },
    data() {
        return {
            token: '',
            loading: {
                status: false,
                message: '',
            },

            directions: [],
            directionId: this.direction_id,

            structure: [],
        }
    },
    computed: {
        directionsOptions: function(){
            let dol = [];
            this.directions.forEach(v => dol.push({label: v.label, value: v.id}));
            return dol;
        },
        checkPrice: function(){
            return this.sumStructureAttribute('price');
        },
        checkDeadlines: function(){
            return this.sumStructureAttribute('deadlines');
        },
    },
    mounted() {
        this.token = document.querySelector("[name=csrf-token]").content;
        // this.loadDirections();
        // if(this.directionId != null && this.directionId > 0){
        //     this.reLoadStructure(this.directionId);
        //     if(this.structure_arr != null){
        //         this.setOldStructure(this.structure_arr);
        //     }
        // }
        (async () => {
            await this.loadDirections();
            
            if(this.directionId != null && this.directionId > 0){
                await this.reLoadStructure(this.directionId);
            
                if(this.structure_arr != null){
                    this.setOldStructure(this.structure_arr);
                }
            }
        })();
    },
    methods: {
        sumStructureAttribute(attr){
            let sum = 0;
            try {
                if (!Array.isArray(this.structure)) {
                    return;
                }
                // Итерируем по структуре
                for (const department of this.structure) {
                    // Используем опциональную цепочку для безопасного доступа к свойствам
                    if (!Array.isArray(department?.workshops)) {
                        continue; // Пропускаем, если workshops отсутствует или не является массивом
                    }
                    // Итерируем по цехам
                    for (const workshop of department.workshops) {
                        if (!Array.isArray(workshop?.productionWorks)) {
                            continue; // Пропускаем, если productionWorks отсутствует или не является массивом
                        }
                        // Итерируем по производственным работам
                        for (const productionWork of workshop.productionWorks) {
                            // Проверяем, что productionWork существует и check === true
                            if (productionWork?.check) {
                                // Суммируем значение атрибута, если оно существует
                                sum += parseFloat(productionWork[attr] || 0);
                            }
                        }
                    }
                }
            } catch (error) {
                console.error("Error in sumStructureAttribute:", error);
            }
            if (!Array.isArray(this.structure)) {
                return sum;
            }
            return sum;
        },
        resetDirection(){
            if(this.directionId !== null && this.directionId !== 0){
                this.reLoadStructure(this.directionId);
            }
        },
 
        setOldStructure(structureArr){
            try{
                if (!Array.isArray(this.structure)) {
                    return;
                }
                this.structure.forEach((department, s) => {
                    department?.workshops?.forEach((workshop, w) => {
                        workshop?.productionWorks?.forEach((productionWork, p) => {
                            if (productionWork) {
                                const structureItem = structureArr[productionWork.id]??null;
                                if (structureItem) {
                                    this.structure[s].workshops[w].productionWorks[p].check = true;
                                    this.structure[s].workshops[w].productionWorks[p].price = structureItem.price ?? productionWork.price;
                                    this.structure[s].workshops[w].productionWorks[p].deadlines = structureItem.deadlines_minutes ?? structureItem.deadlines ?? productionWork.deadlines;
                                    productionWork?.productionSubsWorks?.forEach((productionSubsWork, ps) => {
                                        const structurePsItem = structureArr[productionSubsWork.id]??null;
                                        if(structurePsItem) this.structure[s].workshops[w].productionWorks[p].productionSubsWorks[ps].check = true;
                                    });
                                }
                            }
                        });
                    });
                });
            } catch (error) {
                console.error("Error in setOldStructure:", error);
            }
        },
 
        async reLoadStructure(directionId){
            let _this = this;
            this.loading = { status: true, message: 'обновляем структуру' };
            await axios.post('/web-api/structure/direction-structure/' + directionId,
                { headers: { 'Content-Type': 'application/json', 'X-CSRF-TOKEN': this.token }}
            )
            .then(function(res){
                console.log(res.data);
                if(res.data.status){
                    if(typeof res.data.data.structure != "undefined"){
                        _this.structure = res.data.data.structure;
                        console.log('structure update');
                    }
                } else {
                    console.log(res.data.message);
                    window.getAlert('error', 'Ошибка', res.data.message);
                }
            })
            .catch(function(error){
                console.log(error);
                window.$func.exceptionsHandler(error);
            })
            .then(function(){
                _this.loading = { status: false, message: '' };
            });
            // if(this.newNotifications > 0) setTimeout(this.animateBell(), 1000);
        },

        async loadDirections(){
            let _this = this;
            this.loading = { status: true, message: 'загружаем направления' };
            await axios.post('/web-api/structure/directions', 
                { headers: { 'Content-Type': 'application/json', 'X-CSRF-TOKEN': this.token }}
            )
            .then(function(res){
                console.log(res.data);
                if(res.data.status){
                    if(typeof res.data.data.directions != "undefined"){
                        _this.directions = res.data.data.directions;
                        console.log('load directions');
                    }
                } else {
                    console.log(res.data.message);
                    window.getAlert('error', 'Ошибка', res.data.message);
                }
            })
            .catch(function(error){
                console.log(error);
                window.$func.exceptionsHandler(error);
            })
            .then(function(){
                _this.loading = {
                    status: false,
                    message: '',
                }
            });
            // if(this.newNotifications > 0) setTimeout(this.animateBell(), 1000);
        },
    },
}
</script>